import React from 'react';
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid';
import Utilities from '@util/Utilities';
import { Tooltip } from 'react-tooltip';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import { MarketStateStatDateCompetitorSnapshot } from '@app/model/market_state/MarketStateStatDateCompetitorSnapshot';

const MarketStateForDayPriceParityIndicator: React.FunctionComponent<{
	current: MarketStateStatDateCompetitorSnapshot
	previous: MarketStateStatDateCompetitorSnapshot | undefined
}> = ({ current, previous }) => {

	const { companyHotel } = useSelectedCompanyHotel();

	if (!previous) return <div />;

	const difference = previous.isAvailable() && current.isAvailable() ?  current.getLowestItemForRoom().lowestItem.item.price.amount - previous.getLowestItemForRoom().lowestItem.item.price.amount: 0;

	if (difference === 0) return <div />;

	const hasDifferentRoom = current.getLowestItemForRoom().roomId !== previous.getLowestItemForRoom().roomId;

	const tooltip = (item: MarketStateStatDateCompetitorSnapshot, parityItem: MarketStateStatDateCompetitorSnapshot) => {
		return <Tooltip id={`roomParity_${current.competitorId}`} className="shadow-lg z-50 !opacity-100"
										style={{ backgroundColor: 'white' }}>
			<p className="text-left text-xs text-gray-900"><span>•</span> Compared
				with {companyHotel.settings.calendar.numberOfDaysForPriceParity} days before</p>
			{hasDifferentRoom && <div className="mt-2">
				<p className="text-left text-xs font-semibold text-gray-900">Room Change:</p>
				<p className="text-left text-xs text-gray-500">
					<span>{Utilities.formatDateString(parityItem.getLowestItemForRoom().lowestItem.item.creationDate, 'DD/MM')}</span>: <span>{Utilities.formatPrice(parityItem.getLowestItemForRoom().lowestItem.item.price)}</span> - <span>{parityItem.getLowestItemForRoom().findRoomName(companyHotel)}</span>
				</p>
				<p className="text-left text-xs text-gray-500">
					<span>Last Run</span>: <span>{Utilities.formatPrice(item.getLowestItemForRoom().lowestItem.item.price)}</span> - <span>{item.getLowestItemForRoom().findRoomName(companyHotel)}</span>
				</p>
			</div>}
		</Tooltip>;
	};

	return <div className="inline-flex text-gray-400 text-xs cursor-pointer"
							data-tooltip-id={`roomParity_${current.competitorId}`}>
		<span>•</span>
		{difference > 0 ? <ArrowUpIcon className="w-3.5 h-3.5 text-green-500" /> :
			<ArrowDownIcon className="w-3.5 h-3.5 text-red-500" />}
		<span
			className="italic font-normal">{Utilities.formatAmount(Math.abs(difference), current.getLowestItemForRoom().lowestItem.item.price.currency)}</span>
		{hasDifferentRoom && <div>
			<ExclamationCircleIcon className="w-3.5 h-3.5 ml-1 text-yellow-400 cursor-pointer" />
		</div>}
		{tooltip(current, previous)}
	</div>;

};

export default MarketStateForDayPriceParityIndicator;